import React from 'react';
import logo from './img/CYBER ARCADIA LOGO-07 (1).png';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      {/* Newsletter start  */}
      <div className="container-fluid bg-primary newsletter py-5 mb-5 mt-5 smooth newsLetter">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div
              className="col-md-5 ps-lg-0 mt-5 pt-md-0 text-start wow fadeIn"
              data-wow-delay="0.3s">
            </div>
            <div
              className="col-md-7 p-0 newsletter-text wow fadeIn"
              data-wow-delay="0.5s"
            >
              <div className="footer-container" style={{ display: 'flex', alignItems: 'center', backgroundColor: '#40414e', padding: '20px', borderRadius: '10px' }}>
                <div className="footer-text" style={{ color: 'white', marginRight: '20px', fontSize: '20px' }}>
                  <div className="footer-texts">Connect with us...</div>
                </div>

                <div className="position-relative" style={{ width: '75%' }}>
                  <input
                    className="form-control border-0 rounded-pill ps-4 pe-5"
                    type="text"
                    placeholder="Enter Your Email"
                    style={{ height: '48px', width: '100%' }}
                  />
                  <button
                    type="button"
                    className="btn shadow-none position-absolute top-0 end-0 mt-1 me-2"
                  >
                    <Link to="/contact">
                      <i className="fa fa-paper-plane text-primary fs-4"></i>
                    </Link>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>


      {/* Newsletter end  */}

      {/* footer Start */}

      <div className="container-fluid bg-dark text-white-50 footer pt-5 mt-5" style={{ overflowX: "hidden" }}>
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.1s">
              <a className="d-inline-block mt-5 ">
                <img src={logo} alt="Cyber Security Logo" className="navbar-logo" />
              </a>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.3s">
              <h5 className="text-white mb-4">Get In Touch</h5>
              {/* <p>
                <i className="fa fa-map-marker-alt me-3"></i>C-32 SEC 19 NOIDA G.B NAGAR, NOIDA
              </p> */}
              <p>
                <i className="fa fa-map-marker-alt me-3"></i>14/2 3rd Floor, Gemini Parsn Complex Kodambakkam High Road Nungambakkam, Chennai-600 024
              </p>
              <p>
                <i className="fa fa-phone-alt me-3"></i>+91 8190016663
              </p>
              <p>
                <i className="fa fa-envelope me-3"></i>info@cyberarcadia.in
              </p>
              <div className="d-flex pt-2">

                <a className="btn btn-outline-light btn-social" target='blank' href="https://www.instagram.com/cyber_arcadia_academy?igsh=anVhb21nZjhiN2x6&utm_source=qr">
                  <i className="fab fa-instagram"></i>
                </a>
                <a className="btn btn-outline-light btn-social" href="https://www.linkedin.com/company/cyber-arcadia/about/?viewAsMember=true" target='blank'>
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.5s">
              <h5 className="text-white mb-4">Popular Link</h5>
              <Link to="/about">
                <a className="btn btn-link ">
                  About Us
                </a>
              </Link>
              <Link to="/contact">
                <a className="btn btn-link">
                  Contact Us
                </a>
              </Link>
              <Link to="/career">
                <a className="btn btn-link">
                  Career
                </a>
              </Link>

            </div>

            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.7s">
              <h5 className="text-white mb-4">Our Services</h5>
              {/* <a className="btn btn-link" href="">
        Endpoint Security
        </a> */}


              <p className=' text-decoration-none'>
                Endpoint Security</p>
              <p className=' text-decoration-none'>
                Managed Security Services
              </p>
              <p className=' text-decoration-none'>
                VAPT
              </p>
              <p className=' text-decoration-none'>
                Cloud Security
              </p>
              <p className=' text-decoration-none'>
                Compliance Solutions
              </p>
              <p className=' text-decoration-none'>
                Security Awareness Training
              </p>
              <p className=' text-decoration-none'>
                SOC Support
              </p>
              <p className='text-decoration-none'>
                Data Protection & Encryption
              </p>
              <p className=' text-decoration-none'>
                Network Security
              </p>
              <p className=' text-decoration-none'>
                Security Assurance
              </p>

            </div>
          </div>
        </div>
        <div className="container-fluid wow fadeIn" data-wow-delay="0.1s">
          <div className="copyright">
            <div className="row d-flex justify-content-center">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                &copy;{" "}
                <a className="border-bottom" href="#">
                  Cyber Arcadia
                </a>&nbsp; is a brand of Cybercrest Solution LLP, All Right Reserved. Developed By

                <a className="border-bottom" href="https://enterkeysolutions.com/index.html" target='blank'>
                  {" EnterKey Solutions "}
                </a>{" "}
                {/* Distributed By{" "} */}
                {/* <a className="border-bottom" href="https://themewagon.com">
            ThemeWagon
          </a> */}
              </div>
              {/* <div className="col-md-5 text-center text-md-end">
                <div className="footer-menu">
                  <a href="">Home</a>
                  <a href="">Cookies</a>
                  <a href="">Help</a>
                  <a href="">FAQs</a>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* footer end */}


    </>
  )
}

export default Footer